<template>
    <div>
        <el-card class="box-card main_minheight">
            <div slot="header" class="tishi">
                <span><i class="el-icon-setting"></i>&nbsp;设置</span>

            </div>
            <div style="text-align: center;">
                <!--                            <p :class="sel=='tx'?'tishisel':''" @click="sel='tx'">-->
                <!--                                <router-link to="Upfaceimg" class="caidan">上传头像</router-link>-->
                <!--                            </p>-->
                <!-- <p :class="sel=='zl'?'tishisel':''" @click="sel='zl'">
                    <router-link to="EditUinfo" class="caidan">编辑资料</router-link>
                </p>
                <p :class="sel=='mm'?'tishisel':''" @click="sel='mm'">
                    <router-link to="UpUpass" class="caidan">密码邮箱</router-link>
                </p>

                <!-- <p :class="sel=='zy'?'tishisel':''" @click="sel='zy'" >
                    <router-link :to="'Home?type=myforum&authorId='+lander.uid" class="caidan" >我的主页</router-link>
                </p> 
                <p :class="sel=='ht'?'tishisel':''" @click="sel='ht'" v-if="lander.role=='100'">
                    <router-link to="AdminType" class="caidan">后台管理</router-link>
                </p> 
                <p :class="sel=='tz'?'tishisel':''"   v-if="lander.role=='50'">
                    <router-link to="AdminForum" class="caidan" >帖子管理</router-link>
                </p>   
               
                 <p :class="sel=='tc'?'tishisel':''" class="caidan" @click="logoutHandle">
                    退出登录
                </p>   -->
                <el-menu>
                    <el-menu-item  ><router-link :to="'Home?type=myforum&authorId='+lander.uid">我的主页</router-link></el-menu-item>
                    <el-menu-item  v-if="lander.role=='100'"><router-link to="AdminType">后台管理</router-link></el-menu-item>
                    <el-menu-item  v-if="lander.role=='50'"><router-link to="AdminForum">帖子管理</router-link></el-menu-item>
                    <el-menu-item> <router-link to="EditUinfo" >编辑资料</router-link></el-menu-item>
                    <el-menu-item><router-link to="UpUpass" >密码邮箱</router-link></el-menu-item>
                    <el-menu-item  @click="logoutHandle" >退出登录</el-menu-item>

                </el-menu>
                 
            </div>
        </el-card>

        

    </div>


</template>

<script>
import {logout, getWindowWidth, dealResult,messageSocketUrl} from "../../../api/common";


    export default {
        data() {
            return {
                sel: 'zl',
                sel: 'mm',
                sel: 'zy',
                sel: 'ht',
                sel: 'tz',
                sel: 'tc'


            }
        },
        created() {
        this.lander = JSON.parse(this.$store.state.logininfo);
        this.webW=getWindowWidth();

        this.getmyMessageNotReadNum();
        this. getMessageSocket();


        PubSub.subscribe('changeMyNotReadMessageNum',(msg,index)=>{
            if(index=="1")this. getmyMessageNotReadNum();
        });

        //当其他人发布新帖，下面群组出现小红点
        PubSub.subscribe('newForumReleasedTipAll',(msg,boo)=>{
             this.newForumReleasedTipAllBoo=boo;
        });
         },
        mounted() {
        this.lander = JSON.parse(this.$store.state.logininfo);
        this.webW=getWindowWidth();

        this.getmyMessageNotReadNum();
        this. getMessageSocket();


        PubSub.subscribe('changeMyNotReadMessageNum',(msg,index)=>{
            if(index=="1")this. getmyMessageNotReadNum();
        });

        //当其他人发布新帖，下面群组出现小红点
        PubSub.subscribe('newForumReleasedTipAll',(msg,boo)=>{
             this.newForumReleasedTipAllBoo=boo;
        });

    },
        methods: {
              logoutHandle(){
            logout();
        }
        },

        activated() {


        },
        deactivated() {

        }
    };
</script>

<style scoped>

    .fixedJfLeftMenu {
        position: fixed;
        bottom: 0px;
    }

</style>
